export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/BREA/Desktop/drum-machine/src/environments/environment.ts